module.exports = __webpack_public_path__ + "static/media/4.986520c7.png";